/**
 * UX-014 — shared empty-state text for section/read-view cards.
 *
 * One vocabulary + one style, everywhere: cards render "None entered" in
 * `text-base font-normal leading-6 text-text-body-subtle dark:text-gray-500` (matching the
 * Clinical Summary card) so empty states can't drift in copy, size, or color.
 *
 * Render as its own line inside a card body. Pass `text` only to override the
 * default copy in the rare case a card needs different wording (avoid unless
 * necessary — the whole point is consistency).
 */
export const CARD_EMPTY_STATE_TEXT = 'None entered'
export const CARD_EMPTY_STATE_CLASSES = 'text-base font-normal leading-6 text-text-body-subtle dark:text-gray-500'

export function CardEmptyState({ text = CARD_EMPTY_STATE_TEXT }: { text?: string }) {
  return <p className={CARD_EMPTY_STATE_CLASSES}>{text}</p>
}
